import React from 'react';
import s from './HotCard.scss';
// import { shortLargeInt } from '../../../utils';
import { LinkWrapper } from '../../../components/BaseComp';
// import { FeedInstance} from '../../../models/feed';
import { CisItem, ContentInstance } from '../../../models/apis/batchCisApi';
interface Props {
    title: string,
    dataSource: CisItem[]
}

const CommentItem = ({ item }: { item: CisItem }) => {
    const data = item as ContentInstance;
    return (
        <div className={s.item} data-spm-type="resource">
            <LinkWrapper
                data-spm-type="content"
                href={data.url ? data.url : `/a/${data.id}_${data.authorId}`}
                className={s.feedTitle}
            >
                <p>{data.title}</p>
            </LinkWrapper>
            {/* <LinkWrapper
                href={item.url ? `${item.url}#mpbox` : `/a/${item.id}_${item.authorId}#mpbox`}
                className={s.count}
            >
                <p className={s.counts}>{shortLargeInt(item.cmt || 0)}</p>
                <p className={s.countLabel}>评论</p>
            </LinkWrapper> */}
        </div>
    );
};

const CommentImage = ({ item } : { item: CisItem }) => {
    const data = item as ContentInstance;
    const cover = (data.cover || (data.images && data.images[0]) || '').replace(/w_([\s\S]+?),/g, 'w_520,').replace(/h_([\s\S]+?),/g, 'h_260,');
    return (
        <div className={s.imageFeed}>
            <img src={cover} alt={data.title} className={s.image}/>
            <LinkWrapper href={data.url} className={s.titleBox}>
                <p className={s.title}>
                    {data.title}
                </p>
            </LinkWrapper>
            <div className={s.commentBox}>
                <LinkWrapper href={data.personalPage || data.url}>{data.authorName}</LinkWrapper>
                 {/* · <LinkWrapper href={`${item.url}#mpbox`}> {item.cmt || 0} 评论</LinkWrapper> */}
            </div>
        </div>
    );
};

export const HotCardComment = (props: Props) => {
    const { title, dataSource } = props;

    const data = dataSource.slice(0, 10);

    return (
        <div className={s.cardContainer}>
            <h3 className={s.title}>{title}</h3>
            <ul data-spm="top-hotcomments">
                {
                    data.map((a, index) => {
                        if (index === 0) {
                            return <CommentImage key={index} item={a} />;
                        }
                        return <CommentItem item={a} key={index} />;
                    })
                }
            </ul>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/HomeTop/HotCard/HotCard.comment.tsx